var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-field',{attrs:{"readonly":"","clickable":"","name":"datetimePicker","value":_vm.schema.value,"label":_vm.schema.label,"placeholder":"点击选择","required":_vm.schema.required === true}})
}
var staticRenderFns = []

export { render, staticRenderFns }